import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[toast]',
    standalone: false
})
export class ToastDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
